var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClimateWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 228,
    width: 228,
    viewBox: "7.12 28.57 63.09 73.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "g#Layer_1-2 {    fill=\"#fff\";}.cls-1,.cls-2{fill:none;}.cls-2{stroke:#231f20;stroke-linecap:round;stroke-miterlimit:10;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    fill: "#fff",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,29.14H73.66V102.8H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.16,67.89a25.44,25.44,0,0,1,.21,3A24.53,24.53,0,0,1,55.89,87.5a6.13,6.13,0,0,0-5.83-4.3H47V74a3.08,3.08,0,0,0-3.07-3.07H25.5V64.79h6.14a3.08,3.08,0,0,0,3.07-3.07V55.58h6.14A6.15,6.15,0,0,0,47,49.44V48.18a24.38,24.38,0,0,1,2.95,1.44A12.73,12.73,0,0,1,54,44.85,30.69,30.69,0,1,0,68.5,70.93a31.12,31.12,0,0,0-.4-5A12.58,12.58,0,0,1,62.16,67.89ZM34.71,95.27A24.44,24.44,0,0,1,13.9,65.46L28.57,80.13V83.2a6.15,6.15,0,0,0,6.14,6.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.59,48.45V34a5.43,5.43,0,0,0-10.86,0V48.45a9.05,9.05,0,1,0,10.86,0ZM59.35,34A1.81,1.81,0,0,1,63,34v1.81H61.16v1.81H63v3.62H61.16V43H63v1.81H59.35Zm1.79,25.4a3.45,3.45,0,1,1,3.45-3.45A3.45,3.45,0,0,1,61.14,59.37Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClimateWhite);
export default __webpack_public_path__ + "static/media/climateWhite.c8755c270c4bac4518d89cc2b50399a4.svg";
export { ForwardRef as ReactComponent };